import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setOrdersParams } from "../../entities/actions";
import "./styles.css";
import { OrderRow } from "./orderRow";
import { orderTypeEnum } from "../consts";

export const Orders = ({ currentTick, steps, orders, simulation }) => {
  const [orderQty, setValue] = useState({});
  const [resetValue, setResetValue] = useState("");

  const dispatch = useDispatch();
  const quantityRef = React.useRef();
  const streamOrders = steps[currentTick]?.orders;

  useEffect(() => {
    let newOrders = {};
    orders.forEach((order) => {
      newOrders = {
        ...newOrders,
        [order.order_id]: {
          size: order?.size,
          strat: order?.strat,
          streamRate: { x: order.streamRate.x, y: order.streamRate.y },
          type: order.type,
        },
      };
    });
    setValue(newOrders);
  }, [orders]);

  const updateOrder = (newOrder) => {
    setValue((state) => {
      const newState = {
        ...state,
        [newOrder.order_id]: newOrder,
      };
      dispatch(setOrdersParams(newState));
      return newState;
    });
  };

  const floorQuantity = (number) => Math.floor(number / 10) * 10;

  return (
    <div className="orders-wrapper">
      <div className="orders-header">
        <div className="orders-header-title">Orders</div>
      </div>
      <div className="orders-table-headers-wrapper">
        <div className="orders-table-headers">
          <span className="orders-table-headers-item order-id">Order ID</span>
          <span className="orders-table-headers-item order-type">
            Order Type
          </span>
          <span className="orders-table-headers-item stream-rate-min">Min</span>
          <span className="orders-table-headers-item stream-rate">
            Aggregate Stream Rate
          </span>
          <span className="orders-table-headers-item stream-rate-max">Max</span>
          <span className="orders-table-headers-item average-price">
            Avg Price
          </span>
          <span className="orders-table-headers-item limit">Limit</span>
          <span className="orders-table-headers-item quantity">Quantity</span>
        </div>
      </div>

      <div className="orders-table">
        {orders.map((order, i) => {
          const showLSHOption = !orders.find(
            (e) => e.type === orderTypeEnum.lsh
          );

          return (
            <OrderRow
              showLSHOption={showLSHOption}
              key={order.order_id}
              order={order}
              i={i}
              streamOrders={streamOrders}
              orderQty={orderQty}
              resetValue={resetValue}
              setResetValue={setResetValue}
              simulation={simulation}
              setValue={setValue}
              dispatch={dispatch}
              floorQuantity={floorQuantity}
              currentTick={currentTick}
              quantityRef={quantityRef}
              steps={steps}
              updateOrder={updateOrder}
            />
          );
        })}
      </div>
    </div>
  );
};
